import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getCaJStyleClickOrbisSD,
  getCaJStyleHoverOrbisSD,
} from "../style/curvatureAtJunction";

function getCurvatureInteractions(clickStyle, hoverStyle) {
  return function (layer, control) {
    const clickSelect = new Select({
      layers: [layer],
      condition: click,
      style: function (feature) {
        return clickStyle(feature);
      },
    });
    clickSelect.on("select", function (e) {
      if (e.target.getFeatures().getLength() > 0) {
        control.set(
          "selectedFeatures",
          Array.from(e.target.getFeatures().getArray()),
        ); // create new array so that the event gets triggered
      } else {
        control.set("selectedFeatures", undefined);
      }
    });
    const hoverSelect = new Select({
      layers: [layer],
      condition: pointerMove,
      style: function (feature) {
        return hoverStyle(feature);
      },
    });
    return [clickSelect, hoverSelect];
  };
}

export function getCaJInteractionsOrbisSD() {
  return getCurvatureInteractions(
    getCaJStyleClickOrbisSD,
    getCaJStyleHoverOrbisSD,
  );
}
